module.exports = __webpack_public_path__ + "static/media/tarjeta-cc.c45e4852.svg";